import { ALIGN_MAPPING } from "../constanst";
import { toRGBA } from "../parser/utils";

export default ({ data }) => {
  const {
    label,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    labelColor,
    fontSize,
    fontWeight,
    backgroundColor,
    backgroundImage,
    fitToBackground,
    centerBackgroundImage,
    repeatBackgroundImage,
    align = "center",
    width,
    autoWidth,
    borderColor,
    borderWidth,
    borderRadius,
    borderStyle,
  } = data;

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: ALIGN_MAPPING[align],
      }}
    >
      <div
        style={{
          paddingTop,
          paddingBottom,
          paddingRight,
          paddingLeft,
          alignItems: "center",
          width: autoWidth ? "auto" : `${width}%`,
          backgroundColor: toRGBA(backgroundColor),
          borderColor: toRGBA(borderColor),
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: fitToBackground ? "cover" : "auto",
          backgroundPosition: centerBackgroundImage ? "center top" : "left top",
          backgroundRepeat: repeatBackgroundImage ? "repeat" : "no-repeat",
          borderWidth,
          borderStyle,
          borderRadius,
        }}
      >
        <div
          style={{
            color: toRGBA(labelColor),
            fontSize: fontSize,
            fontWeight: fontWeight,
            textAlign: "center",
          }}
        >
          {label}
        </div>
      </div>
    </div>
  );
};
